import { createSlice } from "@reduxjs/toolkit";
import { CreateUserState, RootState } from "@/types/store";

import {
  inviteAdminUser,
  inviteHomeownerUser,
  inviteSuperAdminUser,
} from "@/api/createUser/thunks";

const initialState: CreateUserState = {
  inviteSuperAdminUserLoading: false,
  inviteAdminUserLoading: false,
  inviteHomeownerUserLoading: false,
  inviteSuperAdminUserError: null,
  inviteAdminUserError: null,
  inviteHomeownerUserError: null,
};

export const CreateUserSlice = createSlice({
  name: "CreateUserSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inviteSuperAdminUser.pending, (state) => {
        state.inviteSuperAdminUserLoading = true;
        state.inviteSuperAdminUserError = null;
      })
      .addCase(inviteSuperAdminUser.fulfilled, (state) => {
        state.inviteSuperAdminUserLoading = false;
      })
      .addCase(inviteSuperAdminUser.rejected, (state, action) => {
        state.inviteSuperAdminUserLoading = false;
        state.inviteSuperAdminUserError = action.payload as string;
      })
      .addCase(inviteAdminUser.pending, (state) => {
        state.inviteAdminUserLoading = true;
        state.inviteAdminUserError = null;
      })
      .addCase(inviteAdminUser.fulfilled, (state) => {
        state.inviteAdminUserLoading = false;
      })
      .addCase(inviteAdminUser.rejected, (state, action) => {
        state.inviteAdminUserLoading = false;
        state.inviteAdminUserError = action.payload as string;
      })
      .addCase(inviteHomeownerUser.pending, (state) => {
        state.inviteSuperAdminUserLoading = true;
        state.inviteHomeownerUserError = null;
      })
      .addCase(inviteHomeownerUser.fulfilled, (state) => {
        state.inviteSuperAdminUserLoading = false;
      })
      .addCase(inviteHomeownerUser.rejected, (state, action) => {
        state.inviteSuperAdminUserLoading = false;
        state.inviteHomeownerUserError = action.payload as string;
      });
  },
});

export const selectInviteSuperAdminLoading = (state: RootState) =>
  state.CreateUser.inviteSuperAdminUserLoading;
export const selectInviteAdminLoading = (state: RootState) =>
  state.CreateUser.inviteAdminUserLoading;
export const selectInviteHomeownerLoading = (state: RootState) =>
  state.CreateUser.inviteHomeownerUserLoading;

export default CreateUserSlice.reducer;
